"use client";

import { BlogThemeProvider } from "@/contexts/blog-theme-context";
import { ReactNode } from "react";

export default function BlogLayout({ children }: { children: ReactNode }) {
  return <BlogThemeProvider>{children}</BlogThemeProvider>;
}
